import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BigqueryService {

  constructor(private http: HttpClient) { }

  onQuery(datasetName: string, q: string) {
    const postParams = {
      datasetName,
      query: q
    };
    return this.http.post(`${environment.app.functionsUrl}/bigQSqlQuery`, postParams);
  }

}
